const config = { 
BASE_URL : "https://server.innoveraschool.com/",
//BASE_URL : "http://localhost:3001/",
SIE_NAME : "Innovera School",
SITE_NAME : "Innovera School"
}
export default config;